(function () {
  'use strict';

  /* @ngdoc object
   * @name auth.impersonation
   * @description
   *
   */
  angular
    .module('auth.impersonation', []);
}());
